import { Component } from '@angular/core';
import { SalesService } from '../sales.service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from '../../../services/common/common.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-payment-plan',
  templateUrl: './payment-plan.component.html',
  styleUrl: './payment-plan.component.scss'
})
export class PaymentPlanComponent {

  recordList!: any[];
  siteId: any;
  paymentPlanId: any = 0;
  showaddUpdateModal: boolean = false;
  paymentSupportData: any
  context: string = '';
  private destroy$ = new Subject<void>();

  constructor(private route: ActivatedRoute, private router: Router, public saleservice: SalesService,
    public commonService: CommonService) {
  }

  ngOnInit() {
    this.paymentPlanId = this.route.snapshot.paramMap.get("id")!;
    this.setSiteId();
    this.getAllPaymentPlan();
  }

  /**
   * updating data on behalf of siteId
   */
  setSiteId() {
    this.siteId = this.commonService.localStorageSiteId;
  }
  getPaymentPlanById(id: any) { }

  /**
   * get payment details
   * @param isSpinnerVisisble For loader
   *
   */
  getAllPaymentPlan() {

    //Get payment-Plan data
    this.commonService.selectedProjects$
      .pipe(takeUntil(this.destroy$)).subscribe((selectedProject: any) => {
        this.recordList = [];
        if (selectedProject != null) {
          this.saleservice.getpaymentPlan().subscribe((res: any) => {
            if (res) {
              this.recordList = res.result
            }
            else {
              this.recordList = [];
            }

            if (this.paymentPlanId != null && this.paymentPlanId != "undefined") {

              let filterPlanObject = {
                showaddUpdateModal: true,
                currentSelectedRecord: this.recordList?.find(x => x.id == parseInt(this.paymentPlanId)),
                isSubmitted: false
              }
              this.changeAddUpdateModelState(filterPlanObject);
            }
          });
        }
      });
  }


  /**
  * Click Close Model Form
  */
  closePaymentDialogue() {
    this.router.navigate(['sales/paymentPlan']);
  }

  /**
   * Open And Close Payment Modal
   */
  changeAddUpdateModelState(modalStatus: any) {
    if (modalStatus?.showaddUpdateModal) {
      this.paymentSupportData = modalStatus?.currentSelectedRecord;
    }

    this.showaddUpdateModal = modalStatus?.showaddUpdateModal;
    if (modalStatus?.context === "Edit") {
      this.context = modalStatus?.context;
    } else {
      this.context = "Add"
    }
    //If record was submitted (added/updated) then refresh the booking list
    if (modalStatus?.isSubmitted) {
      if (this.paymentPlanId != null && this.paymentPlanId != "undefined") {
        this.router.navigate(['sales/paymentPlan']);
      } else {
        this.getAllPaymentPlan();
      }
    }
  }

  ngOnDestroy(): void {
    // Signal completion to clean up subscriptions
    this.destroy$.next();
    this.destroy$.complete();
  }
}
